import { render } from "./ModificacionManual.vue?vue&type=template&id=4d1a57bc"
import script from "./ModificacionManual.vue?vue&type=script&lang=js"
export * from "./ModificacionManual.vue?vue&type=script&lang=js"

import "./ModificacionManual.vue?vue&type=style&index=0&id=4d1a57bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__